'use client';
"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
var _default = useIsomorphicLayoutEffect;
exports.default = _default;